import { useState, useEffect } from 'react';
import axiosInstance from '../utils/axiosInstance';
import useDataSelect from '../hooks/useDataSelect';
import { useSnackbar } from '../contexts/SnackbarProvider';
import GlobalError from '../components/GlobalError';
import { useForm } from 'react-hook-form';
import ClientInfoForm from '../components/ClientInfoForm';
import { Typography, Button, Stack, Alert, Divider } from '@mui/material';
import { Sync, Mail, Close, Edit, Delete } from '@mui/icons-material';

const ClientDetailPage = ({ logout }) => {
    const { showSnackbar } = useSnackbar();
    const { dataset: clientData, setDataset: setClientData, loading, error, refetch } = useDataSelect(`/client/detail`);  // フックでデータを取得
    const { register, handleSubmit, control, watch, formState: { errors }, setValue, reset } = useForm({
        defaultValues: {
            industry_id: clientData?.industry_id || '',
            payment_method_id: clientData?.payment_method_id || '',
        }
    });
    const [isEditMode, setIsEditMode] = useState(false);

    const onSubmit = async (data) => {
        if (data.items.length < 1) {
            showSnackbar('担当者は1人以上登録してください。', 'warn');
            return;
        }
        try {
            await axiosInstance.put(`/client/detail/update`, data);
            showSnackbar('お客様情報が更新されました', 'success');
            setIsEditMode(false);
            refetch();
        } catch (err) {
            if (process.env.NODE_ENV === 'development') console.error(err);
            showSnackbar(err?.response?.data?.message || '更新に失敗しました', 'error');
        }
    };
    // 取引先を無効にするボタンのクリック
    const handleInvalidate = async () => {
        const isConfirmed = window.confirm(
            '本当に退会しますか？退会後は復元できません。'
        );
        if (!isConfirmed) return;

        try {
            await axiosInstance.put(`/client/invalidate`);
            showSnackbar('退会しました', 'success');
            setTimeout(() => { logout(); }, 800);
        } catch (err) {
            if (err.response?.status === 404) {
                showSnackbar('すでに削除されているか、存在しないアカウントです', 'error');
                setTimeout(() => { logout(); }, 800);
                return;
            }
            if (process.env.NODE_ENV === 'development') console.error(err);
            showSnackbar(err?.response?.data?.message || '更新に失敗しました', 'error');
        }
    };
    if (error) return <GlobalError errorMessage={error} />;
    if (!clientData) return null;

    return (
        <>
            <Typography variant="h1" component="h1">お客様情報</Typography>
            {/*error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    {error || 'お客様情報がありません'}
                </Alert>
            )*/}
            <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
                <ClientInfoForm
                    clientData={clientData}
                    setClientData={setClientData}
                    isEditMode={isEditMode}
                    setIsEditMode={setIsEditMode}
                    handleInvalidate={handleInvalidate}
                    register={register}
                    errors={errors}
                    setValue={setValue}
                    control={control}
                    watch={watch}
                    refetch={refetch}
                    reset={reset}
                />
                {/*!error && (*/
                    <div className="button-row">
                        <Button
                            variant='outlined'
                            startIcon={isEditMode ? <Close /> : <Edit />}
                            onClick={() => {
                                if (isEditMode) { refetch(); }
                                setIsEditMode(prev => !prev);
                            }}
                        >
                            {isEditMode ? '編集を破棄する' : '設定を編集する'}
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            disabled={!isEditMode}
                            startIcon={<Sync />}
                        >
                            内容を更新する
                        </Button>
                    </div>
                /*)*/}
                <Divider sx={{ mt: 6 }} />
                <Button
                    variant='outlined'
                    color='error'
                    onClick={() => handleInvalidate()}
                    sx={{ mt: 6 }}
                >
                    退会する
                </Button>
            </form>
        </>
    );
};

export default ClientDetailPage;
